// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"9bcdb266","787":"a227f313","975":"a1d8e9f1"}[chunkId] + ".chunk.js";
};